/**
 * Radiobutton Group - Responsive dropdown functionality
 */

document.addEventListener('DOMContentLoaded', () => {
    const radiobuttonGroups = document.querySelectorAll('[data-radiobutton-group].vacancy-style');

    radiobuttonGroups.forEach(group => {
        const toggle = group.querySelector('.dropdown-toggle');
        const dropdownLabel = group.querySelector('.dropdown-label');
        const radiobuttons = group.querySelectorAll('input[type="radio"]');

        if (!toggle || !dropdownLabel) return;

        // Update dropdown label with selected option
        const updateLabel = () => {
            const checked = group.querySelector('input[type="radio"]:checked');
            if (checked) {
                // Find the label element (could be .atm-form-label or label tag)
                const labelElement = checked.closest('.atm-form-radiobutton')?.querySelector('.atm-form-label, label');
                if (labelElement) {
                    dropdownLabel.textContent = labelElement.textContent.trim();
                }
            } else {
                // Set default text if nothing is selected
                dropdownLabel.textContent = 'Selecteer een categorie';
            }
        };

        // Toggle dropdown
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // Close other open dropdowns
            document.querySelectorAll('[data-radiobutton-group].vacancy-style.is-open').forEach(otherGroup => {
                if (otherGroup !== group) {
                    otherGroup.classList.remove('is-open');
                }
            });
            
            group.classList.toggle('is-open');
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (!group.contains(e.target)) {
                group.classList.remove('is-open');
            }
        });

        // Handle radio button selection
        radiobuttons.forEach(radio => {
            radio.addEventListener('change', () => {
                updateLabel();
                // Close dropdown on mobile after selection
                if (window.innerWidth <= 768) {
                    setTimeout(() => {
                        group.classList.remove('is-open');
                    }, 150);
                }
            });
        });

        // Initialize label with current selection
        updateLabel();
    });
});
